import animator from './modules/animator';
import setViewportHeight from './modules/setViewportHeight';
import setFixedOffset from './modules/setFixedOffset';
import preloader from './modules/preloader';
import './modules/ajax';
import contactForm from './modules/contactForm';

setViewportHeight.init();
setFixedOffset.init();
animator.init();
preloader.init();
contactForm.init();